// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c3da242c]:export{primaryColor:#64b5f6;secondaryColor:#003c60;accentColor:#c41230}.tc-number[data-v-c3da242c]{margin:0 0 0 4px}.v-footer[data-v-c3da242c]{color:#000}.logo[data-v-c3da242c]{max-height:150px}.terms-and-conditions[data-v-c3da242c]{font-size:13.2px}.logo-jakafi[data-v-c3da242c]{width:171px;height:auto}", ""]);
// Exports
module.exports = exports;
